export const containerStyles = {
  padding: '16px 0px',
  color: 'text.grey',
  // bg: 'background.main',
  justifyContent: 'center',
  alignItems: 'center',
};
export const flexBoxStyles = {
  direction: 'column' as 'column',
  gap: '24px',
  textStyle: 'body1',
};
export const buttonStyles = {
  display: 'block',
  width: '100%',
  borderRadius: '2px'
}